export default __webpack_public_path__ + "static/media/mypic.f1e05a69.jpeg";